export default __webpack_public_path__ + "static/media/loading.92a20fed.svg";